module.exports = __webpack_public_path__ + "img/mi1.7913f43d.png";